import React from 'react';
import { FiPlus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function SectionHeader({ title, description, buttonText, onButtonClick }) {
  return (
    <div className="flex items-end justify-between mb-6 pl-4 flex-wrap gap-3">
      <div>
        <h2 className="font-playfair text-2xl font-bold text-ink">{title}</h2>
        <p className="font-lora text-[0.95rem] text-ink-light mt-1">{description}</p>
      </div>
      {buttonText && (
        <button
          onClick={onButtonClick}
          className="inline-flex items-center gap-1.5 bg-ink text-parchment border-none rounded px-5 py-2 font-lora text-[0.84rem] cursor-pointer transition-all shadow-card hover:bg-ink-mid hover:-translate-y-[1px] whitespace-nowrap"
        >
          <SafeIcon icon={FiPlus} />
          {buttonText}
        </button>
      )}
    </div>
  );
}